import { render, staticRenderFns } from "./managerReview.vue?vue&type=template&id=072cd2c0"
import script from "./managerReview.vue?vue&type=script&lang=js"
export * from "./managerReview.vue?vue&type=script&lang=js"
import style0 from "./managerReview.vue?vue&type=style&index=0&id=072cd2c0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports